import { render, staticRenderFns } from "./AppNavigationHeader.vue?vue&type=template&id=b85aa258"
import script from "./AppNavigationHeader.vue?vue&type=script&lang=js"
export * from "./AppNavigationHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports